import React from 'react';

export function SkeletonRow() {
  return (
    <div className="bg-gray-800 rounded-xl px-4 py-4 border border-gray-700 animate-pulse flex items-center justify-between">
      <div className="flex-1">
        <div className="h-4 bg-gray-700 rounded w-1/3 mb-2" />
        <div className="h-3 bg-gray-700/60 rounded w-1/2" />
      </div>
      <div className="h-8 w-16 bg-gray-700 rounded-lg" />
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="bg-gray-800 rounded-xl px-4 py-3 border border-gray-700 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="h-4 bg-gray-700 rounded w-1/3" />
        <div className="h-5 w-5 bg-gray-700 rounded" />
      </div>
      <div className="h-3 bg-gray-700/60 rounded w-1/2 mt-2" />
    </div>
  );
}

export function SkeletonList({ count = 5, variant = 'row' }) {
  const Component = variant === 'card' ? SkeletonCard : SkeletonRow;
  return (
    <div className={variant === 'card' ? 'grid gap-2 sm:grid-cols-2 lg:grid-cols-3' : 'space-y-2'}>
      {Array.from({ length: count }).map((_, i) => <Component key={i} />)}
    </div>
  );
}
